import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  divider: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
}));

const HelpItemsList = ({ messages }) => {
  const classes = useStyles();
  return (
    <>
      {messages.map((message, index) => (
        <Box key={message}>
          <Typography
            variant="body1"
            color="primary"
          >
            <FormattedMessage id={message} />
          </Typography>
          <Typography
            variant="body1"
            className={index < messages.length - 1 ? classes.divider : undefined}
          >
            <FormattedMessage id={`${message}.description`} />
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default HelpItemsList;
